import React, { useState } from 'react';
import { X, ChevronDown } from 'lucide-react';

export default function FilterPopup({
  showFilters,
  setShowFilters,
  selectedCategory,
  setSelectedCategory,
  selectedLevel,
  setSelectedLevel,
  minPrice,
  setMinPrice,
  maxPrice,
  setMaxPrice,
  categories,
  levels,
  handleApplyFilters,
  handleResetFilters
}) {
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);

  if (!showFilters) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={(e) => {
      if (e.target === e.currentTarget) setShowFilters(false);
    }}>
      <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl overflow-hidden">
        
        <div className="flex justify-between items-center p-5 border-b border-gray-100">
          <h3 className="text-xl font-semibold text-gray-900">Filter Courses</h3>
          <button
            onClick={() => setShowFilters(false)}
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>
        
        <div className="p-5 space-y-6">
         
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Price Range
            </label>
            <div className="flex gap-3 items-center">
              <div className="flex-1">
                <input
                  type="number" placeholder="Min Price" value={minPrice} onChange={(e) => setMinPrice(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"/>
              </div>
              <span className="text-gray-400">—</span>
              <div className="flex-1">
                <input type="number" placeholder="Max Price" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"/>
              </div>
            </div>
            <p className="mt-2 text-xs text-gray-500 flex items-center gap-1">
             
             ₹ Note: All courses are currently free (₹0)
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Categories
            </label>
            <div className="relative">
              <button
                onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
                className="w-full px-3 py-2 text-left border border-gray-300 rounded-lg flex justify-between items-center hover:border-orange-300 transition-colors bg-white"
              >
                <span className={selectedCategory === 'All' ? 'text-gray-500' : 'text-gray-900'}>
                  {selectedCategory === 'All' ? 'All Categories' : selectedCategory}
                </span>
                <ChevronDown className="w-4 h-4 text-gray-500" />
              </button>
              {showCategoryDropdown && (
                <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-10 overflow-y-auto max-h-75">
                  {categories.map(category => (
                    <button
                      key={category}
                      onClick={() => {
                        setSelectedCategory(category);
                        setShowCategoryDropdown(false);
                      }}
                      className={`w-full px-3 py-2 text-left hover:bg-orange-50 transition-colors text-sm ${
                        selectedCategory === category ? 'bg-orange-50 text-orange-600 font-medium' : 'text-gray-700'
                      }`}
                    >
                      {category === 'All' ? 'All Categories' : category}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Course Level
            </label>
            <div className="flex gap-2 flex-wrap">
              {levels.map(level => (
                <button
                  key={level}
                  onClick={() => setSelectedLevel(level)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    selectedLevel === level
                      ? 'bg-orange-500 text-white shadow-md'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {level === 'All' ? 'All Levels' : level}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="flex gap-3 p-5 border-t border-gray-100 bg-gray-50">
          <button
            onClick={handleResetFilters}
            className="flex-1 px-4 py-2.5 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 transition-colors text-sm"
          >
            Reset All
          </button>
          <button
            onClick={handleApplyFilters}
            className="flex-1 px-4 py-2.5 rounded-lg bg-gradient-to-r from-orange-500 to-orange-600 text-white font-medium hover:from-orange-600 hover:to-orange-700 transition-all shadow-sm"
          >
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
}